import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';
import Navbar from './components/Navbar'
import Header from './components/Header'
import Contact from './components/Contact'
import Particle from 'react-particles-js'
import About from './components/About'
import Services from './components/Services'
import { BrowserRouter,Route,Switch  } from 'react-router-dom'
import Portfolio from './components/Portfolio';
// import './i18n';


function App() {
 
  return (
    <BrowserRouter>
        <Switch>
            
            <Route exact path="/">
                <Navbar/>
                <Particle className=".parceles-canvas" params={{
                    particles:{
                        number:{
                            value:30,
                            density:{enable:true,value_area:900}
                        }
                    },
                    shape:{
                        type:"circle",
                        strok:{with:6,color:"#f9ab00"}

                    }
                }}/>
                <Header/>
            </Route>

            <Route exact path="/about">
                <Navbar/>
                <About/>
            </Route>
            
            <Route exact path="/services">
                <Navbar/>
                <Services/>
            </Route>

            <Route exact path="/contact">
                <Navbar/>
                <Contact/>
            </Route>

            <Route exact path="/portfolio">
                <Navbar/>
                <Portfolio/>
            </Route>

        </Switch>
    </BrowserRouter>
  );
}

export default App;
